require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./services-xxxxxxxxx.json") })
        }
      }, "path---services-xxxxxxxxx");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---services-xxxxxxxxx!./.cache/json/services-xxxxxxxxx.json
// module id = 1487
// module chunks = 231608221292675